import React, { useMemo, useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import {FlagIcon} from 'react-flag-kit';

import avatarFemale from "../../../VisitCard/images/avatar_female.png";
import avatarMale from "../../../VisitCard/images/avatar_male.png";

import './style.less'
import moment from "moment";

import NotesIcon from '../../../svg/Notes';
import VideocamIcon from '../../../svg/Videocam';
import InfoCircleIcon from '../../../svg/InfoCircle';
import Tooltip from "../../../Tooltip"
import { useHistory } from 'react-router-dom';
import { isMobile } from '../../../../utils/responsive';
import Drawer from '../../../Drawer';

const componentLabel = 'dashboard_list_item'

const RoundedCircleFlag = ({code}) => {

  return (
    <div className={'RoundedCircleFlag'}>
      <div className={'CountryFlagCircle'}
           style={{backgroundImage: `url(https://github.com/madebybowtie/FlagKit/raw/master/Assets/PNG/${code}@2x.png?raw=true)`}}/>
    </div>
  )
}

function ageLabel(age) {
  const {t} = useTranslation();
  let ageGroup = {'kid': '<18', 'young': '19-25', 'youngadult': '26-35', 'adult': '36-49', 'old': '50+'}[age];
  return `${ageGroup} ${t('years')}`
}

function getAge(birthday) {
  if (birthday) {
    let split = birthday.split("-");
    const { t } = useTranslation();
    return (split && split.length > 0) ? `${(moment().year() - split[split.length - 1])} ${t('years')}` : "";
  }
}

const TenantInfo = ({ tenant, move_details, type, nameStyle, listType }) => {

  const { t } = useTranslation();
  const history = useHistory();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const stay = useMemo(() => {
    if (!move_details) return "";
    if (move_details?.stay) return move_details.stay;
    return moment(move_details?.move_out).diff(moment(move_details?.move_in), 'months');
  }, [move_details]);

  const stayInDays = () => {
    if (move_details?.move_out && move_details?.move_in) {
      let splitMoveIn = move_details?.move_in.split("/");
      let moveIn = splitMoveIn?.[2] + "-" + splitMoveIn?.[1] + "-" + splitMoveIn?.[0];
      let splitMoveOut = move_details?.move_out.split("/");
      let moveOut = splitMoveOut?.[2] + "-" + splitMoveOut?.[1] + "-" + splitMoveOut?.[0];
      return moment(moveOut, "YYYY/MM/DD").diff(moment(moveIn, "YYYY/MM/DD"), 'days');
    }
  }

  if(!tenant) return null;
  const personalDetails = {...(tenant.personalDetails || tenant)};

  const openTenantDetails = (e) => {
    e.preventDefault();
    history.push(`/leads/${tenant.id}/details/`);
  }

  return (
    <div className={(`TenantInfo ${type}` + (listType === "offer" ? " noMaxWidth" : ""))}>

      <div className="tenant__photo avatar-container"
        style={{ backgroundImage: `url(${tenant.photo || (personalDetails?.gender === "female" ? avatarFemale : avatarMale)})` }}
        onClick={openTenantDetails}
      >
        {personalDetails?.nationality && <RoundedCircleFlag code={personalDetails?.nationality.toUpperCase()} />}
      </div>

      <div className="tenant__info">
        <div className="tenant__info__name">
          <h4 onClick={openTenantDetails}>{tenant.name}</h4>
          <div className="tenant__info__icons" onClick={openTenantDetails}>
            {tenant?.personalDetails?.extraInfo && <div className="icon">
              <NotesIcon />
            </div>}
            {tenant?.tenantVideo && <div className="icon" onClick={openTenantDetails}>
              <VideocamIcon />
            </div>}
          </div>
        </div>

        <div className="tenant__personal-details">
          {`${t('gender.' + personalDetails?.gender)} · 
            ${(personalDetails?.age ? ageLabel(personalDetails?.age) : (personalDetails?.birthdate ? getAge(personalDetails?.birthdate) : ""))} · 
            ${personalDetails?.occupation && t(componentLabel + "." + personalDetails?.occupation)}`}
        </div>
        <div className={"tenant__email-phone"}>
            {personalDetails?.email && <a className={"tenant__email"} href={`mailto:${personalDetails.email}`}>{personalDetails.email}</a>}
            {personalDetails?.phone && <a className={"tenant__phone"} href={`tel:${personalDetails.dialCode + personalDetails.phone}`}>{personalDetails.dialCode + " " + personalDetails.phone}</a>}
        </div>

        {move_details && <div className={'RequestDates'}>
            {listType !== "PotentialTenants" &&
                <>
                    <p className={'small'}>
              <span>{t(componentLabel + '.entry_date')}:</span> {move_details.move_in?.replace(/ /g, "/")}</p>
                    <p className={'small'}>
              <span>{t(componentLabel + '.exit_date')}:</span> {move_details.move_out?.replace(/ /g, "/")}</p>
                </>}
          {/* {(move_details && listType !== "offer") &&
                <p className={'small'}>
                    <span>{t(componentLabel + '.totalStay') + ': '}</span>
                  {tenant.preferences.stayLength ? (tenant.preferences.stayLength + " " + (stay > 1 ? t('months') : t('month')))
                      : `${stay > 0 ? stay : stayInDays()}
                  ${stay > 0 ? (stay > 1 ? t('months') : t('month')) : (stayInDays() > 1 ? t('days') : t('day'))}`}
                </p>} */}
            {(listType !== "PotentialTenants" && listType !== "offer") &&
                <p className={'small link link_blue'}>{t(componentLabel + '.future_payments_details')}</p>}
          </div>}
        {/* <p className={'small mobile'}>
          <span>{t(componentLabel + '.registration_date')}</span>&nbsp;{moment(tenant.registrationDate).format("DD/MM/YYYY")}
        </p> */}
        </div>

    </div>
  )

}

export default TenantInfo;
